import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

import Footer from '../components/Footer';
import Loading from '../components/loading';
import { UserRoles } from '../constants/roles';
import { RootState } from '../redux-store/store';

interface IPrivateRoute {
  children: Array<JSX.Element> | JSX.Element;
  roles: Array<UserRoles>;
}

const PrivateRoute = ({ children, roles }: IPrivateRoute) => {
  const isLoggedIn = useSelector((state: RootState) => state.auth.isLoggedIn);
  const loading = useSelector((state: RootState) => state.auth.loading);
  const currentUser = useSelector((state: RootState) => state.auth.currentUser);

  const location = useLocation();

  const params = new URL(document.location as any).searchParams;
  const registrationId: any = params.get('registrationId');
  const phoneNumber: any = params.get('phonenumber');

  if (registrationId) {
    window.localStorage.setItem('registrationId', registrationId);
  }

  if (phoneNumber) {
    window.localStorage.setItem('phoneNumber', phoneNumber);
  }

  const grantAccess = (userRoles: string) => {
    let access = false;
    const userRolesJson = JSON.parse(userRoles); // json of logged in user roles
    if (
      roles.includes(UserRoles.ALL) ||
      roles.includes(UserRoles.GLOBAL_USERS_ROLE)
    ) {
      return true;
    } else {
      for (let index = 0; index < roles.length && !access; index++) {
        const role = roles[index];
        if (userRolesJson[role]) {
          access = true;
        }
      }
    }
    return access;
  };

  return (
    <div>
      {loading ? (
        <div className='full-page-loader'>
          <Loading showLogo text='Loading...' />
        </div>
      ) : (
        <>
          {isLoggedIn ? (
            grantAccess(currentUser.user_roles) ? (
              <>
                {children}
                <Footer footerHeight='45px' />
              </>
            ) : (
              <Navigate to='/not-found' />
            )
          ) : (
            <Navigate to='/' state={{ from: location }} replace />
          )}
        </>
      )}
    </div>
  );
};

export default PrivateRoute;
